import Utils from './Utils'
import { fetch as fetchPolyfill } from 'whatwg-fetch'

class Leadhit {
  constructor (raven, store) {
    this.description = 'Main Leadhit object'
    this.raven = raven
    this.store = store
    this.fetch = fetchPolyfill

    this.isWidgetSystemInitialized = false

    let GETqueryDict = {}

    location.search.substr(1).split('&').forEach(function (item) {
      GETqueryDict[item.split('=')[0]] = item.split('=')[1]
    })

    this.GETqueryDict = GETqueryDict

    //  IE polyfill for the CustomEvent constructor
    if (typeof window.CustomEvent === 'function') {
      // If not IE
      this.CustomEvent = window.CustomEvent
    } else {
      let customEvent = function (event, params) {
        params = params || {
          bubbles: false,
          cancelable: false,
          detail: undefined
        }
        var evt = document.createEvent('CustomEvent')
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
        return evt
      }

      customEvent.prototype = window.Event.prototype

      this.CustomEvent = customEvent
    }
  }
  // Add event listener
  addEvent (elem, evType, fn) {
    let elems = []

    if (Object.prototype.toString.call(elem) === '[object Array]') {
      elems = elem
    } else {
      elems = [elem]
    }

    for (let i = 0; i < elems.length; i++) {
      elem = elems[i]

      if (elem.addEventListener) {
        elem.addEventListener(evType, fn, false)
      } else if (elem.attachEvent) {
        elem.attachEvent('on' + evType, fn)
      } else {
        elem['on' + evType] = fn
      }
    }
  }

  // Add event listener by selector
  addEventLive (elementQuerySelector, eventType, cb) {
    document.addEventListener(eventType, function (event) {
      var qs = document.querySelectorAll(elementQuerySelector)
      if (qs) {
        var el = event.target
        var index = -1
        while (el && ((index = Array.prototype.indexOf.call(qs, el)) === -1)) {
          el = el.parentElement
        }

        if (index > -1) {
          cb.call(el, event)
        }
      }
    })
  }

  CustomEvent () {
    // This defines in constructor
    return false
  }

  readCookie (name) {
    // Backward compatibility
    return Utils.readCookie(name)
  }

  setCookie (name, value, expires, path, domain, secure) {
    return Utils.setCookie(name, value, expires, path, domain, secure)
  }

  getUID () {
    return this.readCookie('_lhtm_u')
  }

  genUID () {
    // Backward compatibility
    return Utils.genUID()
  }

  getVisitId () {
    let sess = this.readCookie('_lhtm_r')
    if (sess) {
      return sess.split('|')[1]
    } else {
      return window.lh_vid
    }
  }

  getURLParameter (name, str) {
    return Utils.getURLParameter(name, str)
  }

  getReferrer () {
    return Utils.getReferrer()
  }

  makeQuery (params) {
    // Backward compatibility
    return Utils.makeQuery(params)
  }

  addToCart (itemUrl, itemsCount) {
    try {
      if (this.store.state.siteSettings.hasOwnProperty('next_vers_features') && this.store.state.siteSettings.next_vers_features.hasOwnProperty('add_to_cart') && this.store.state.siteSettings.next_vers_features.add_to_cart === true) {
        let cartParams = {
          item_id: '0',
          item_url: itemUrl || document.location.toString(),
          event_type: itemUrl ? 'catalog' : 'item',
          lead_id: this.getUID(),
          visit_id: this.getVisitId(),
          site_id: window.lh_clid
        }
        if (itemsCount) {
          cartParams.items_count = itemsCount
        }

        let url = this.store.state.proto + this.store.state.trackUrlV2 + 'add_to_cart'
        this.sendBeacon(url, JSON.stringify(cartParams))
      } else {
        var cartParams = {
          item_id: '0',
          item_url: itemUrl || document.location.toString(),
          event_type: itemUrl ? 'catalog' : 'item',
          uid: this.getUID(),
          vid: this.getVisitId(),
          clid: window.lh_clid // FIXME: This is unobvious
        }
        if (itemsCount) {
          cartParams.items_count = itemsCount
        }
        this.loadScript(
          this.store.state.proto + this.store.state.baseTrackUrl + 'lh_stat/add_to_cart?' + Utils.makeQuery(cartParams),
          () => {}
        )
      }
      let cartEvent = new this.CustomEvent('addToCartLH')
      document.dispatchEvent(cartEvent)
    } catch (e) {
      this.debugLog(e)
    }
  }

  addToFavorites (itemUrl) {
    try {
      if (this.store.state.siteSettings.hasOwnProperty('next_vers_features') && this.store.state.siteSettings.next_vers_features.hasOwnProperty('add_to_favorites') && this.store.state.siteSettings.next_vers_features.add_to_favorites === true) {
        let cartParams = {
          item_id: '0',
          item_url: itemUrl || document.location.toString(),
          event_type: itemUrl ? 'catalog' : 'item',
          lead_id: this.getUID(),
          visit_id: this.getVisitId(),
          site_id: window.lh_clid
        }
        let url = this.store.state.proto + this.store.state.trackUrlV2 + 'add_to_favorites'
        this.sendBeacon(url, JSON.stringify(cartParams))
      } else {
        var cartParams = {
          clid: window.lh_clid, // FIXME: This is unobvious
          uid: this.getUID(),
          item_url: itemUrl || document.location.toString()
        }
        this.loadScript(
          this.store.state.proto + this.store.state.baseTrackUrl + 'lh_stat/add_to_favorites?' + Utils.makeQuery(cartParams),
          () => {}
        )
      }
      let favoritesEvent = new this.CustomEvent('addToFavoritesLH')
      document.dispatchEvent(favoritesEvent)
    } catch (e) {
      this.debugLog(e)
    }
  }

  setVisitNumberWhenCartDataWasAdded () {
    let currentVisit = localStorage.getItem('_lh_visits_count')

    localStorage.setItem('_lh_visit_number_when_cart_data_was_added', currentVisit)
  }

  createCookie (name, value, minutes, esc) {
    return Utils.createCookie(name, value, minutes, esc)
  }

  getStringByQS (selector) {
    var el = document.querySelector(selector)
    return (el ? el.innerText || el.innerHTML || el.data || el.value : '').replace(/\u00a0/g, ' ')
  }

  getStringByXPath (query) {
    try {
      var elCartSum = document.evaluate(
        window.lh_vars['cart_sum_query'], document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null
      ).singleNodeValue
      return elCartSum.innerText || elCartSum.innerHTML || elCartSum.data
    } catch (e) {
      return ''
    }
  }

  loadScript (url, cb) {
    var sc = document.createElement('script')
    sc.type = 'text/javascript'
    sc.src = url
    sc.charset = 'utf-8'
    var head = document.getElementsByTagName('head')[0]
    sc.onreadystatechange = sc.onload = cb
    head.appendChild(sc)
  }

  log (str) {
    console.log((new Date()).toISOString() + ' :: ' + str)
  }

  debugLog (message) {
    if (this.store.state.debug) {
      this.log(message)
    }
  }

  nearest (el, query) {
    if (el.tagName.toLowerCase() === 'html' || !el.parentNode) return false

    // checks current element itself
    var els = el.parentNode.querySelectorAll(query)
    for (let i = 0; i < els.length; i++) {
      if (els[i] === el) {
        return el
      }
    }

    let result = el.querySelector(query)
    return result || this.nearest(el.parentElement, query)
  }

  saveFormToLocalStorage (form) {
    if (!form) {
      return
    }

    var lhDiffTime = localStorage.getItem('lhDiffTime')

    if (!form._lh_formid) {
      form._lh_formid = Utils.genUID()
    }

    var params = {}

    for (let el of form.elements) {
      if (el.type !== 'password' && el.name) {
        params['f_' + el.name] = Utils.getElemValue(el)
      }
    }

    let leadhitForm = {
      query: Utils.makeQuery(params),
      action: (form.attributes['action'] || { value: '' }).value,
      save_time: Date.now()
    }

    if (this.store.state.orderButtons.length > 0) {
      for (let i = 0; i < this.store.state.orderButtons.length; i++) {
        if (form === this.nearest(this.store.state.orderButtons[i], 'form')) {
          leadhitForm['lh_order'] = true
        }
      }
    }

    leadhitForm['form_added_time'] = parseInt(lhDiffTime) + Date.now()

    let formKey = `LeadhitForm:${this.store.state.pageID}:${form._lh_formid}`

    localStorage.setItem(formKey, JSON.stringify(leadhitForm))
  }

  saveItemUrl (name, url) {
    var ItemUrl = JSON.parse(localStorage['lhItemUrl'])
    ItemUrl[name] = url
    localStorage['lhItemUrl'] = JSON.stringify(ItemUrl)
  }

  sendWidgetStats (wid, event, payload) {
    var params = {
      'wid': wid,
      'etype': event,
      'uid': this.getUID(),
      'vid': this.getVisitId(),
      'clid': window.lh_clid
    }

    let widgetEvent = new this.CustomEvent('widgetStatsSended', {
      bubbles: false,
      cancelable: false,
      detail: params
    })
    document.dispatchEvent(widgetEvent)

    if (this.store.state.siteSettings.hasOwnProperty('next_vers_features') && this.store.state.siteSettings.next_vers_features.hasOwnProperty('widgets') && this.store.state.siteSettings.next_vers_features.widgets === true) {
      let url = this.store.state.proto + this.store.state.trackUrlV2 + 'widgets_stat'
      let requestBody = {
        widget_id: wid,
        site_id: window.lh_clid,
        lead_id: this.getUID(),
        visit_id: this.getVisitId(),
        event: event,
        payload: payload || {}
      }
      return this.sendBeacon(url, JSON.stringify(requestBody))
    } else {
      var url = this.store.state.proto + this.store.state.baseTrackUrl + 'lh_stat/widgets?' + Utils.makeQuery(params)
      return this.sendBeacon(url, JSON.stringify({ payload: payload || {} }))
    }
  }

  sendBeacon (url, data) {
    if (!!navigator && !!navigator.sendBeacon && !navigator.userAgent.indexOf('Chrome')) {
      return navigator.sendBeacon(url, data)
    } else {
      return this.fetch(url, { method: 'POST', body: data })
    }
  }

  checkDisabledForms () {
    for (let i = 0; i < this.disabledSelectors.length; i++) {
      var disabledForms = document.querySelectorAll(this.disabledSelectors[i])
      var disabledForm = document.querySelector(this.disabledSelectors[i])
      if (disabledForm && this.store.state.disabledForms.indexOf(disabledForm) === -1) {
        for (let i = 0; i <= disabledForms.length; i++) {
          this.store.state.disabledForms.push(disabledForms[i])
        }
      }
    }
  }

  wrapToForm (el, formAction) {
    var form = document.createElement('form')
    form.action = formAction || ''
    el.parentNode.insertBefore(form, el)
    form.appendChild(el)
    return form
  }

  async saveElementForm (element) {
    var form = (Utils.closestByTagName(element, 'form'))
    await this.checkDisabledForms()
    if (this.store.state.disabledForms.indexOf(form) === -1) {
      this.saveFormToLocalStorage(form)
    }
  }

  sendFormToLeadhit (leadhitForm, key, submitted) {
    var params = {}

    let splittedKey = key.split(':')

    params['url'] = location.toString().split('#')[0]
    params['uid'] = this.getUID()
    params['vid'] = this.getVisitId()
    params['ref'] = Utils.getReferrer()
    params['formid'] = splittedKey[2]

    try {
      params['f_cart_sum'] = this.getStringByQS(window.lh_vars['cart_sum_query'])
    } catch (e) {
      params['f_cart_sum'] = ''
      this.raven.captureException(e)
    }

    if (
      params.hasOwnProperty('f_cart_sum') && (typeof params['f_cart_sum'] === 'undefined' || params['f_cart_sum'] === '')) {
      delete params['f_cart_sum']
    }

    if (submitted || !leadhitForm['lh_order']) {
      params['action'] = leadhitForm['action'] || `http://${document.location.host.replace('www.', '')}${document.location.pathname}`
    } else {
      params['action'] = 'lhAutoForms'
    }

    let formUrl = this.store.state.proto + this.store.state.baseTrackUrl +
                  'lh_stat/lead_form?' + leadhitForm['query'] + '&' + Utils.makeQuery(params) +
                  '&clid=' + window.lh_clid + '&form_added_time=' + leadhitForm['form_added_time']

    // drop too long urls
    if (formUrl.length >= 2000) {
      localStorage.removeItem(key)
      return false
    }

    // drop empty forms
    if (!leadhitForm['query']) {
      localStorage.removeItem(key)
    } else {
      this.fetch(formUrl).then(function (response) {
        if (response.headers.get('content-type') === 'text/javascript') {
          response.text().then(() => {
            let cookieNames = ['lh_banner_closed', 'lh_mobile_banner_closed', 'lh_wheel_fortune_closed', 'lh_scratch_closed']
            let date = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365)
            for (let j = 0; j < cookieNames.length; j++) {
              Utils.createCookie(cookieNames[j], 1, date.toUTCString(), false)
            }
          }).catch(
            function (e) {
              this.raven.captureException(e)
            }.bind(this)
          )
        }
        this.debugLog('Form sent')
        localStorage.removeItem(key)
      }.bind(this)).catch(
        function (e) {
          localStorage.removeItem(key)
          this.raven.captureException(e)
        }.bind(this)
      )
    }
  }

  newSendFormToLeadhit (leadhitForm, key, submitted) {
    if (!leadhitForm['query']) {
      localStorage.removeItem(key)
    } else {
      let splittedKey = key.split(':')
      let url = this.store.state.proto + this.store.state.trackUrlV2 + 'save/lead/form'
      let requestBody = {
        site_id: window.lh_clid,
        lead_id: this.getUID(),
        form_id: splittedKey[2],
        url: location.toString().split('#')[0],
        referrer: this.getReferrer(),
        form_fields: {},
        time_added: leadhitForm['form_added_time']
      }
      leadhitForm['query'] = decodeURIComponent(leadhitForm['query'])
      let fields = leadhitForm['query'].split('&')
      for (let i = 0; i < fields.length; i++) {
        let field = fields[i].split('=')
        requestBody.form_fields[field[0]] = field[1]
      }

      if (submitted || !leadhitForm['lh_order']) {
        requestBody.action = leadhitForm['action'] || `http://${document.location.host.replace('www.', '')}${document.location.pathname}`
      } else {
        requestBody.action = 'lhAutoForms'
      }

      this.fetch(url, { method: 'POST', body: JSON.stringify(requestBody) })
        .then(function (response) {
          response.text()
            .then(function (response) {
              try {
                response = JSON.parse(response)
                if (response.hasOwnProperty('disable_banner') && response.disable_banner === true) {
                  let cookieNames = ['lh_banner_closed', 'lh_mobile_banner_closed', 'lh_wheel_fortune_closed', 'lh_scratch_closed']
                  let date = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365)
                  for (let j = 0; j < cookieNames.length; j++) {
                    Utils.createCookie(cookieNames[j], 1, date.toUTCString(), false)
                  }
                }
                this.debugLog('Form sent')
                localStorage.removeItem(key)
              } catch (e) {
                localStorage.removeItem(key)
                this.raven.captureException(e)
              }
            }.bind(this))
            .catch(function (e) {
              localStorage.removeItem(key)
              this.raven.captureException(e)
            }.bind(this))
        }.bind(this))
        .catch(function (e) {
          localStorage.removeItem(key)
          this.raven.captureException(e)
        }.bind(this))
    }
  }

  sendFormsFromLocalStorage (submitted) {
    var localKeys = Object.keys(localStorage)
    for (let i = 0; i < localKeys.length; i++) {
      if (localKeys[i].indexOf(`LeadhitForm:${this.store.state.pageID}`) !== -1) {
        let leadhitForm = localStorage.getItem(localKeys[i])
        if (this.store.state.siteSettings.hasOwnProperty('next_vers_features') && this.store.state.siteSettings.next_vers_features.hasOwnProperty('save_lead_form') && this.store.state.siteSettings.next_vers_features.save_lead_form === true) {
          this.newSendFormToLeadhit(JSON.parse(leadhitForm), localKeys[i], submitted)
        } else {
          this.sendFormToLeadhit(JSON.parse(leadhitForm), localKeys[i], submitted)
        }
      }
    }
  }

  checkOrSetOrderButtons () {
    if (typeof orderSelectors === 'undefined') {
      console.warn('Leadhit: Variable orderSelectors is not defined')
      return
    }

    for (let i = 0; i < orderSelectors.length; i++) {
      var orderButton = document.querySelector(orderSelectors[i])
      if (orderButton && this.store.state.orderButtons.indexOf(orderButton) === -1) {
        this.store.state.orderButtons.push(orderButton)
      }
    }
  }

  async sendOrderForm (orderButton) {
    var form = this.nearest(orderButton, 'form')
    await this.checkDisabledForms()
    if (this.store.state.disabledForms.indexOf(form) === -1) {
      this.saveFormToLocalStorage(form)
      this.sendFormsFromLocalStorage(true)
    }
  }

  initWidgetSystem () {
    if (this.isWidgetSystemInitialized) {
      return
    }
    this.isWidgetSystemInitialized = true
    var widgetsSrc = 'https://media.leadhit.io/scripts/widgetsystem/bundle.js'
    if (localStorage.getItem('leadhit_widgets_test') === 'on') {
      widgetsSrc = 'https://media.dev.leadhit.io/widgetsystem/bundle.js'
    } else if (localStorage.getItem('leadhit_widgetsystem_path') !== null) {
      widgetsSrc = localStorage.getItem('leadhit_widgetsystem_path')
    }
    if (document.querySelector(`[src="${widgetsSrc}"]`)) {
      return
    }

    var lh = document.createElement('script')
    lh.type = 'text/javascript'
    lh.async = true
    lh.src = widgetsSrc
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(lh, s)
  }

  setFormListeners () {
    Utils.setFormIdToForms()
    if (typeof (disabledSelectors) !== 'undefined') {
      this.disabledSelectors = disabledSelectors.concat(this.store.state.defaultDisabledForms)
    } else {
      this.disabledSelectors = this.store.state.defaultDisabledForms
    }

    document.removeEventListener('mouseup', this.mouseupFormListner.bind(this))
    document.addEventListener('mouseup', this.mouseupFormListner.bind(this))

    // TODO: We strongly need to check this
    document.removeEventListener('input', this.inputFormListner.bind(this))
    document.addEventListener('input', this.inputFormListner.bind(this))

    // TODO: We strongly need to check this
    document.removeEventListener('select', this.selectFormListner.bind(this))
    document.addEventListener('select', this.selectFormListner.bind(this))

    clearInterval(this.store.state.intervalSendFormsFromLocalStorage)
    this.store.state.intervalSendFormsFromLocalStorage = null
    this.store.state.intervalSendFormsFromLocalStorage = setInterval(() => { this.sendFormsFromLocalStorage(false) }, 2000)
  }

  mouseupFormListner (event) {
    this.checkOrSetOrderButtons()
    if (this.store.state.orderButtons.indexOf(event.target) !== -1) {
      this.sendOrderForm(event.target)
    }
  }

  async inputFormListner (event) {
    if (Utils.detectChromeAutoFill(event)) {
      this.debugLog('Chrome autofill dropped')
      return false
    }

    var form = Utils.closestByTagName(event.target, 'form')
    await this.checkDisabledForms()
    if (this.store.state.disabledForms.indexOf(form) === -1) {
      this.saveFormToLocalStorage(form)
    }
  }

  async selectFormListner (event) {
    var form = Utils.closestByTagName(event.target, 'form')
    await this.checkDisabledForms()
    if (this.store.state.disabledForms.indexOf(form) === -1) {
      this.saveFormToLocalStorage(form)
    }
  }

  loadSiteVariables () {
    var url = this.store.state.proto + this.store.state.baseTrackUrl + 'lh_stat/lh_vars?' + 'clid=' + window.lh_clid
    if (this.store.state.siteSettings.hasOwnProperty('next_vers_features') && this.store.state.siteSettings.next_vers_features.hasOwnProperty('widgets') && this.store.state.siteSettings.next_vers_features.widgets === true) {
      url = this.store.state.proto + this.store.state.trackUrlV2 + 'get/lh_vars?site_id=' + window.lh_clid
    }
    this.fetch(url).then((response) => {
      response.text().then((text) => {
        try {
          eval.call(window, text) // eslint-disable-line
        } catch (err) {
          console.log('error in "lh_stat/lh_vars" response text: ', err)
        }
        this.checkLeadEmailExistAndSetToLocalstorage().then(() => {
          this.setFormListeners()
          this.initWidgetSystem()
        })
      }).catch((e) => {
        this.debugLog(e)
      }
      )
    }).catch((e) => {
      this.debugLog(e)
    }
    )
  }

  checkLeadEmailExistAndSetToLocalstorage () {
    return new Promise(resolve => {
      if (window.hasOwnProperty('need_request_check_lead_email_exist') && window.need_request_check_lead_email_exist === true) {
        const checkID = function () {
          let leadId = this.getUID()

          if (!leadId) {
            if (!this.store.state.timerCheckLeadEmailExistAndSetToLocalstorage) {
              this.store.state.timerCheckLeadEmailExistAndSetToLocalstorage = setInterval(checkID, 500)
              setTimeout(function () {
                if (this.store.state.timerCheckLeadEmailExistAndSetToLocalstorage) {
                  clearInterval(this.store.state.timerCheckLeadEmailExistAndSetToLocalstorage)
                  this.store.state.timerCheckLeadEmailExistAndSetToLocalstorage = null
                }
              }.bind(this), 3000)
            }
          } else {
            if (this.store.state.timerCheckLeadEmailExistAndSetToLocalstorage) {
              clearInterval(this.store.state.timerCheckLeadEmailExistAndSetToLocalstorage)
              this.store.state.timerCheckLeadEmailExistAndSetToLocalstorage = null
            }
            let url = this.store.state.proto + this.store.state.trackUrlV2 + 'check/lead/email_exist?lead_id=' + leadId + '&site_id=' + window.lh_clid
            this.fetch(url).then((response) => {
              response.text().then((result) => {
                result = JSON.parse(result)
                localStorage.setItem('lh_lead_email_exist', result.email_exist)
                resolve()
              })
            })
          }
        }.bind(this)
        checkID()
      } else {
        resolve()
      }
    })
  }

  consumeFormsFromClosedPages () {
    let localKeys = Object.keys(localStorage)
    for (let key of localKeys) {
      let anotherPage = key.indexOf(this.store.state.pageID) === -1
      let isLeadhitForm = key.indexOf('LeadhitForm') !== -1
      if (isLeadhitForm && anotherPage) {
        let currentForm = JSON.parse(localStorage.getItem(key))
        if (Date.now() - currentForm['save_time'] > 10000) {
          localStorage.removeItem(key)
          let splittedKey = key.split(':')
          splittedKey[1] = this.store.state.pageID
          currentForm['save_time'] = Date.now()
          localStorage.setItem(splittedKey.join(':'), JSON.stringify(currentForm))
          this.debugLog('form consumed')
        }
      }
    }
  }

  processVisit () {
    try {
      var params = {}

      let referrer = Utils.getReferrer()

      if (this.store.state.isFirstVisit) {
        // Get leadId from url if possible(used in the mailing)
        let leadId = Utils.getURLParameter('lead_id')
        if (!Utils.checkIsValidObjectIdForMongoDB(leadId)) {
          this.getLeadIdRequest()
            .then(function (response) {
              if (response.status === 200) {
                response.text()
                  .then(function (text) {
                    try {
                      leadId = JSON.parse(text)[window.lh_clid]
                      this.setLeadIdCookies(leadId, params, referrer)
                    } catch (error) {
                      this.debugLog('error in parse response text ' + error)
                    }
                  }.bind(this))
                  .catch((e) => {
                    this.debugLog('Error in get lead id: ' + e)
                    this.debugLog(e)
                  })
              } else {
                this.debugLog('Error in get lead id: ' + response)
              }
            }.bind(this))
            .catch((error) => {
              this.debugLog('Error in get lead id: ' + error)
              this.debugLog(error)
            })
        } else {
          this.setLeadIdCookies(leadId, params, referrer)
        }
      } else {
        this.callbacksIfExistLeadId(params, referrer)
      }
    } catch (e) {
      this.debugLog('Error in processVisit catch' + e)
      this.debugLog(e)
    }
  }

  getLeadIdRequest () {
    if (this.store.state.siteSettings.hasOwnProperty('next_vers_features') && this.store.state.siteSettings.next_vers_features.hasOwnProperty('initialize') && this.store.state.siteSettings.next_vers_features.initialize === true) {
      let urlLeadId = this.store.state.proto + this.store.state.leadInitUrlV2 + 'initialize?site_id=' + window.lh_clid
      return this.fetch(urlLeadId)
    } else {
      let urlLeadId = this.store.state.proto + this.store.state.leadInitUrl + 'initialize?site_id=' + window.lh_clid
      return this.fetch(urlLeadId, {
        credentials: 'include'
      })
    }
  }

  setLeadIdCookies (leadId, params, referrer) {
    Utils.createCookie('_lhtm_u', leadId, 60 * 24 * 3650, false)
    let oldVisitId = Utils.genUID()
    Utils.createComplexCookie('_lhtm_r', [referrer, oldVisitId], 60 * 24 * 3650, true)
    window.lh_vid = oldVisitId
    window.lh_ref = referrer

    this.callbacksIfExistLeadId(params, referrer)
  }

  callbacksIfExistLeadId (params, referrer) {
    this.sendStatCounterServer(params, referrer)
    this.updateLeadState()
    this.startTicker()
  }

  sendStatCounterServer (params, referrer) {
    // if (this.store.state.isSendLhcounter_server) return
    if (this.store.state.siteSettings.hasOwnProperty('next_vers_features') && this.store.state.siteSettings.next_vers_features.hasOwnProperty('process_lead_page_load') && this.store.state.siteSettings.next_vers_features.process_lead_page_load === true) {
      let url = this.store.state.proto + this.store.state.trackUrlV2 + 'handle_lead_page_load'
      let requestBody = {
        site_id: window.lh_clid,
        lead_id: this.getUID(),
        referer: referrer,
        page: window.location.href
      }
      if (localStorage.getItem('_lh_stock_id')) {
        requestBody.stock_id = localStorage.getItem('_lh_stock_id')
      }
      this.fetch(url, { method: 'POST', body: JSON.stringify(requestBody) })
    } else {
      params['ref'] = referrer
      params['vid'] = this.getVisitId()
      params['uid'] = this.getUID()
      params['location'] = document.location.toString().split('#')[0]
      if (localStorage.getItem('_lh_stock_id')) {
        params['stock_id'] = localStorage.getItem('_lh_stock_id')
      }
      var i = document.createElement('img')
      var trackUrl = this.store.state.proto + this.store.state.baseTrackUrl + 'lh_stat/lhcounter_server?' + this.makeQuery(params) + '&clid=' + window.lh_clid
      i.src = trackUrl
    }
    this.debugLog('counter_server request start')
    // this.store.state.isSendLhcounter_server = true
  }

  updateLeadState () {
    // С этим куском кода некорректно обновляются номера визитов, пришлось закомментировать
    // let now = new Date().getTime()
    // let lhLastTick = parseInt(localStorage.getItem('_lh_lastTick'))
    // let diff = now - lhLastTick
    // console.log(now, lhLastTick, diff)
    // if (localStorage.getItem('_lh_visits_count') && new Date(diff).getMinutes() < 2) {
    //   return
    // }
    var url = this.store.state.proto + this.store.state.baseTrackUrl + 'lh_stat/lead_state?' + 'site_id=' + window.lh_clid + '&lead_id=' + Utils.readCookie('_lhtm_u')
    if (this.store.state.siteSettings.hasOwnProperty('next_vers_features') && this.store.state.siteSettings.next_vers_features.hasOwnProperty('lead_state') && this.store.state.siteSettings.next_vers_features.lead_state === true) {
      let params = {
        site_id: window.lh_clid,
        lead_id: Utils.readCookie('_lhtm_u')
      }
      url = this.store.state.proto + this.store.state.trackUrlV2 + 'lead_state?' + this.makeQuery(params)
    }
    this.fetch(url)
      .then(function (response) {
        response.text()
          .then(function (jsonData) {
            try {
              let data = JSON.parse(jsonData)
              if (Object.keys(data).includes('error')) {
                if (data.error === 'Active visit not found' && !this.store.state.timerUpdateLeadState) {
                  this.store.state.timerUpdateLeadState = setInterval(this.updateLeadState.bind(this), 500)
                  setTimeout(function () {
                    clearInterval(this.store.state.timerUpdateLeadState)
                    this.store.state.timerUpdateLeadState = null
                  }.bind(this), 1500)
                } else {
                  this.debugLog(data.error)
                }
              } else {
                clearInterval(this.store.state.timerUpdateLeadState)
                this.store.state.timerUpdateLeadState = null
                Object.keys(data).forEach(function (dataKey) {
                  localStorage.setItem(`_lh_${dataKey}`, data[dataKey])
                })
              }
            } catch (error) {
              this.debugLog(error)
            }
          }.bind(this))
          .catch((e) => {
            this.debugLog(e)
          })
      }.bind(this))
      .catch((e) => {
        this.debugLog(e)
      })
  }

  sendTick (forced) {
    // Needs to avoid multiple queries from several tabs
    let timeElapse = new Date().getTime() - localStorage.getItem('_lh_lastTick') > this.store.state.tickInterval
    if (timeElapse || forced) {
      localStorage.setItem('_lh_lastTick', new Date().getTime())

      if (this.store.state.siteSettings.hasOwnProperty('next_vers_features') && this.store.state.siteSettings.next_vers_features.hasOwnProperty('tick') && this.store.state.siteSettings.next_vers_features.tick === true) {
        let params = {
          site_id: window.lh_clid,
          lead_id: this.getUID(),
          visit_id: this.getVisitId()
        }

        let url = this.store.state.proto + this.store.state.trackUrlV2 + 'tick?' + this.makeQuery(params)

        this.fetch(url)
          .then(function () {
            let lhDiffTime = parseInt(localStorage.getItem('_lh_lastTick')) - new Date().getTime()
            localStorage.setItem('lhDiffTime', lhDiffTime)
          })
      } else {
        let params = {
          'uid': this.getUID(),
          'vid': this.getVisitId()
        }

        let url = this.store.state.proto + this.store.state.baseTrackUrl + 'lh_stat/tick?' + this.makeQuery(params) + '&clid=' + window.lh_clid

        this.fetch(url, { method: 'POST' })
          .then(Utils.SetDiffTime)
      }

      this.debugLog('tick sent')
    };
  }

  startTicker () {
    this.sendTick(true)
    setInterval(this.sendTick.bind(this), this.store.state.tickInterval)
  }

  startCollectorForClosedPagesForms () {
    setInterval(this.consumeFormsFromClosedPages.bind(this), this.store.state.tickInterval)
  }

  disableBannerByGET (arg, disablers) {
    if (disablers.indexOf(this.GETqueryDict[arg]) !== -1) {
      var date = new Date()
      var minutes = 3600 * 3600
      var n = (date.getTime()) / 1000
      date.setTime(date.getTime() + (minutes * 60 * 1000))
      Utils.setCookie('lh_banner_filled', n, date)
    }
  }

  checkOfferPage () {
    let pageUrl = location.toString().split('#')[0]
    let requestUrl = this.store.state.proto + this.store.state.baseTrackUrl + 'offers/check_availability'
    let nextVersFeaturesWidgets = false
    if (this.store.state.siteSettings.hasOwnProperty('next_vers_features') && this.store.state.siteSettings.next_vers_features.hasOwnProperty('widgets') && this.store.state.siteSettings.next_vers_features.widgets === true) {
      nextVersFeaturesWidgets = true
      requestUrl = this.store.state.proto + this.store.state.trackUrlV2 + 'offers/check_availability'
    }
    let state = this.store.state
    var xhr = new XMLHttpRequest()
    xhr.open('POST', requestUrl, true)
    xhr.responseType = 'json'
    xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8')
    xhr.onreadystatechange = function () {
      if (this.readyState !== 4 || !this.response) return
      if (!nextVersFeaturesWidgets) {
        state.isOfferPage = this.response['is_offer']
        state.pageOfferAvailable = this.response['available']
      } else {
        try {
          let responseResult = JSON.parse(this.response)
          state.isOfferPage = responseResult['is_offer']
          state.pageOfferAvailable = responseResult['available']
        } catch (err) {}
      }
    }
    xhr.send(JSON.stringify({
      'page_url': pageUrl,
      'site_id': window.lh_clid
    }))
  }

  offerPagesCountIncrement () {
    var localStorage = window.localStorage
    if (!localStorage) return
    var lhOfferCounter = localStorage.getItem('lh_offer_pages_count')
    if (!lhOfferCounter) {
      localStorage.setItem('lh_offer_pages_count', 1)
    } else {
      try {
        lhOfferCounter = JSON.parse(lhOfferCounter)
        lhOfferCounter++
        localStorage.setItem('lh_offer_pages_count', lhOfferCounter)
      } catch (error) {}
    }
  }

  clientCheckOfferPageAndCount (params) {
    if (params.hasOwnProperty('type')) {
      if (params.type === 'selector') {
        if (params.hasOwnProperty('operator') && params.hasOwnProperty('value')) {
          try {
            var requiredElement = document.querySelector(params.value)
            if (params.operator === 'exist') {
              if (requiredElement) {
                this.offerPagesCountIncrement()
                return true
              } else {
                return false
              }
            } else if (params.operator === 'not_exist') {
              if (!requiredElement) {
                this.offerPagesCountIncrement()
                return true
              } else {
                return false
              }
            }
          } catch (err) {}
        }
      } else if (params.type === 'url') {
        if (params.hasOwnProperty('operator') && params.hasOwnProperty('value')) {
          try {
            var currentUrl = window.location.href
            var regEx = new RegExp(params.value)
            var match = currentUrl.match(regEx)
            if (params.operator === 'match') {
              if (match && match.length > 0) {
                this.offerPagesCountIncrement()
                return true
              } else {
                return false
              }
            } else if (params.operator === 'not_match') {
              if (!match || match.length === 0) {
                this.offerPagesCountIncrement()
                return true
              } else {
                return false
              }
            }
          } catch (err) {}
        }
      }
    }
  }

  setCacheKey (key, expireTime) {
    let url = `${this.store.state.proto}${this.store.state.baseTrackUrl}cache/set`
    if (this.store.state.siteSettings.hasOwnProperty('next_vers_features') && this.store.state.siteSettings.next_vers_features.hasOwnProperty('widgets') && this.store.state.siteSettings.next_vers_features.widgets === true) {
      url = this.store.state.proto + this.store.state.trackUrlV2 + 'cache/set'
    }
    let requestData = {
      'key': key
    }

    if (expireTime) {
      requestData['expire_time'] = expireTime
    }
    this.sendBeacon(url, JSON.stringify(requestData))
  }

  checkCacheKey (key) {
    let url = `${this.store.state.proto}${this.store.state.baseTrackUrl}cache/check`
    if (this.store.state.siteSettings.hasOwnProperty('next_vers_features') && this.store.state.siteSettings.next_vers_features.hasOwnProperty('widgets') && this.store.state.siteSettings.next_vers_features.widgets === true) {
      url = this.store.state.proto + this.store.state.trackUrlV2 + 'cache/check'
    }
    return this.fetch(url, { method: 'POST', body: JSON.stringify({ 'key': key }) })
  }

  getUniqueSelector (element, selector) {
    let newElementSelector = ''
    newElementSelector = element.nodeName.toLowerCase()

    if (element.hasAttribute('id')) {
      newElementSelector = newElementSelector + '#' + element.id
    }
    if (element.classList && element.classList.length > 0) {
      newElementSelector = newElementSelector + '.' + Array.from(element.classList).join('.')
    }

    if (selector.length === 0) {
      selector = newElementSelector + selector
    } else {
      selector = newElementSelector + ' ' + selector
    }

    let checkResult = document.querySelectorAll(selector)
    if (checkResult.length === 1) {
      return selector
    } else if (checkResult.length > 1) {
      return this.getUniqueSelector(element.parentNode, selector)
    } else {
      alert('Уникальный селектор для выбранного элемента не был найден!')
      return ''
    }
  }
  checkExistParentFormElementInFormCollector (element) {
    if (element.nodeName === 'FORM') {
      return true
    } else if (element.parentNode) {
      return this.checkExistParentFormElementInFormCollector(element.parentNode)
    } else {
      return false
    }
  }
  addSelectedFieldToFormInFormCollector (selector, type, name) {
    let freeFields = this.getAllFreeFieldsInFormCollector()
    if (freeFields && freeFields.length > 0) {
      let field = {
        name: {
          key: freeFields.some(field => field.name === type) ? type : freeFields[0].name,
          value: name
        },
        alias: {
          key: freeFields.some(field => field.name === type) ? type : freeFields[0].name,
          value: ''
        },
        selector: {
          key: freeFields.some(field => field.name === type) ? type : freeFields[0].name,
          value: selector
        }
      }
      this.store.state.editableForm.fields.push(field)
      console.log('this.store.state.editableForm.fields', this.store.state.editableForm.fields)
    }

    this.turnOffFindingElementInPageInFormCollector()

    this.renderFormCollectorEditPage()
  }
  turnOffFindingElementInPageInFormCollector () {
    if (document.body.onmouseover) {
      document.body.onmouseover = null
    }
    if (document.body.onmouseout) {
      document.body.onmouseout = null
    }
    if (this.store.state.formCollectorFieldNode) {
      if (this.store.state.formCollectorFieldNode.onclick) {
        this.store.state.formCollectorFieldNode.onclick = null
      }
      this.store.state.formCollectorFieldNode.style.background = this.store.state.formCollectorFieldColor
      this.store.state.formCollectorFieldNode = null
    }
  }
  getInputSelectorInFormCollector (event) {
    event.preventDefault()
    event.stopPropagation()

    const name = event.target.name || ''
    const type = event.target.type || ''

    let selector = ''

    let isFormElement = this.checkExistParentFormElementInFormCollector(event.target.parentNode)
    if (this.store.state.editableForm.hasOwnProperty('standard_form_element')) {
      if (this.store.state.editableForm.standard_form_element === true) {
        if (isFormElement) {
          this.addSelectedFieldToFormInFormCollector(selector, type, name)
        } else {
          alert('Выбранное поле не относится к текущей форме!')
        }
      } else if (this.store.state.editableForm.standard_form_element === false) {
        if (isFormElement) {
          alert('Выбранное поле не относится к текущей форме!')
        } else {
          selector = this.getUniqueSelector(event.target, '')
          this.addSelectedFieldToFormInFormCollector(selector, type, name)
        }
      }
    } else {
      if (isFormElement) {
        this.store.state.editableForm.standard_form_element = true
      } else {
        selector = this.getUniqueSelector(event.target, '')
        this.store.state.editableForm.standard_form_element = false
      }
      this.addSelectedFieldToFormInFormCollector(selector, type, name)
    }
  }
  findFieldMouseoverInFormCollector (event) {
    if (event.target.nodeName !== 'INPUT') return

    event.target.onclick = this.getInputSelectorInFormCollector.bind(this)

    this.store.state.formCollectorFieldColor = event.target.style.background
    this.store.state.formCollectorFieldNode = event.target
    event.target.style.background = 'rgba(255, 68, 2, 0.5)'
  }
  findFieldMouseoutInFormCollector (event) {
    if (event.target.nodeName !== 'INPUT') return

    event.target.style.background = this.store.state.formCollectorFieldColor
    this.store.state.formCollectorFieldNode = null
    event.target.onclick = null
  }

  getButtonSelectorInFormCollector (event) {
    event.preventDefault()
    event.stopPropagation()

    let selector = this.getUniqueSelector(event.target, '')
    this.store.state.editableForm.by_click.selector = selector

    this.turnOffFindingElementInPageInFormCollector()

    this.renderFormCollectorEditPage()
  }
  findButtonMouseoverInFormCollector (event) {
    if (event.target.closest('.lh-form-collector-shadow-continer')) return
    event.target.onclick = this.getButtonSelectorInFormCollector.bind(this)

    this.store.state.formCollectorFieldColor = event.target.style.background
    this.store.state.formCollectorFieldNode = event.target
    event.target.style.background = 'rgba(255, 68, 2, 0.5)'
  }
  findButtonMouseoutInFormCollector (event) {
    event.target.style.background = this.store.state.formCollectorFieldColor
    this.store.state.formCollectorFieldNode = null
    event.target.onclick = null
  }

  getExistingFormById (id) {
    let index = this.store.state.existingForms.findIndex(function (form) {
      if (form.id === id) return true
      else return false
    })
    if (index !== -1) {
      return this.store.state.existingForms[index]
    } else {
      return null
    }
  }
  getAllFreeFieldsInFormCollector () {
    let freeFields = this.store.state.formFields.filter(function (field) {
      let index = this.store.state.editableForm.fields.findIndex(function (existField) {
        if (existField.name.key === field.name) return true
        else return false
      })
      if (index !== -1) return false
      else return true
    }.bind(this))
    return freeFields
  }
  addFieldTypeListSelectInFormCollector () {
    let shadowContainer = document.querySelector('.lh-form-collector-shadow-continer')
    let selectFieldTypeCont = shadowContainer.shadowRoot.querySelectorAll('.lh-form-collector-form-editor-select-field-type')

    let freeFields = this.getAllFreeFieldsInFormCollector()

    if (selectFieldTypeCont && selectFieldTypeCont.length > 0) {
      Array.from(selectFieldTypeCont).forEach(function (selectFieldTypeElement) {
        let fieldType = selectFieldTypeElement.getAttribute('data-field-type')
        let index = this.store.state.formFields.findIndex(function (formField) {
          if (formField.name === fieldType) return true
          else return false
        })

        let freeFieldsItems = ''
        if (freeFields && freeFields.length > 0) {
          freeFieldsItems += `<select data-field-type="${this.store.state.formFields[index].name}">
          <option disabled selected hidden>
            ${this.store.state.formFields[index].title}
          </option>`

          for (let i = 0; i < freeFields.length; i++) {
            freeFieldsItems += `<option data-name="${freeFields[i].name}">
              ${freeFields[i].title}
            </option>`
          }
          freeFieldsItems += '</select>'
        }

        selectFieldTypeElement.innerHTML = freeFieldsItems
      }.bind(this))
    }

    setTimeout(function () {
      let selectFieldTypeElements = shadowContainer.shadowRoot.querySelectorAll('.lh-form-collector-form-editor-select-field-type select')
      if (selectFieldTypeElements && selectFieldTypeElements.length > 0) {
        Array.from(selectFieldTypeElements).forEach(function (selectFieldTypeElement) {
          selectFieldTypeElement.onchange = function (fieldType) {
            let selectElement = shadowContainer.shadowRoot.querySelector(`.lh-form-collector-form-editor-select-field-type select[data-field-type="${fieldType}"]`)
            let selectedType = selectElement.options[selectElement.selectedIndex].getAttribute('data-name')

            this.store.state.editableForm.fields = this.store.state.editableForm.fields.map(function (field) {
              if (field.name.key === fieldType) {
                field.name.key = selectedType
                field.alias.key = selectedType
                field.selector.key = selectedType
              }
              return field
            })

            selectFieldTypeElement.setAttribute('data-field-type', selectedType)
            selectFieldTypeElement.parentNode.setAttribute('data-field-type', selectedType)

            setTimeout(function () {
              this.updateFormFieldsBlock()
            }.bind(this), 0)
          }.bind(this, selectFieldTypeElement.getAttribute('data-field-type'))
        }.bind(this))
      }
    }.bind(this), 0)
  }
  updateFormFieldsBlock () {
    let shadowContainer = document.querySelector('.lh-form-collector-shadow-continer')
    let formFieldsBlock = shadowContainer.shadowRoot.querySelector('.lh-form-collector-form-editor-content-fields-cont')

    let fieldsItems = ''
    if (this.store.state.editableForm.fields && this.store.state.editableForm.fields.length > 0) {
      fieldsItems += `<table class="lh-form-collector-form-editor-content-fields-container">
      <thead>
        <tr>
          <th>
            Тип поля
          </th>
          <th>
            Атрибут 'name' поля
          </th>
          <th>
            Псевдоним поля
          </th>
          <th ${this.store.state.editableForm.standard_form_element ? 'hidden' : ''}>
            Селектор поля
          </th>
          <th>
            Удалить
          </th>
        </tr>
      </thead>
      <tbody>`
      for (let i = 0; i < this.store.state.editableForm.fields.length; i++) {
        let field = this.store.state.editableForm.fields[i]

        let selectorValue = 'value=""'
        if (field.selector.value) {
          let matchDoubleQuotes = field.selector.value.match(/"/g)
          let matchSingleQuotes = field.selector.value.match(/'/g)
          if (matchDoubleQuotes && matchDoubleQuotes.length > 0) {
            selectorValue = `value='${field.selector.value}'`
          } else if (matchSingleQuotes && matchSingleQuotes.length > 0) {
            selectorValue = `value="${field.selector.value}"`
          } else {
            selectorValue = `value="${field.selector.value}"`
          }
        }

        fieldsItems += `<tr>
          <td>
            <div class="lh-form-collector-form-editor-select-field-type" data-field-type="${field.name.key}">
            </div>
          </td>
          <td>
            <input type="text" class="lh-form-collector-field-name-input" value="${field.name.value}" data-field-type="${field.name.key}">
          </td>
          <td>
            <input type="text" class="lh-form-collector-field-alias-input" value="${field.alias.value || ''}" data-field-type="${field.name.key}">
          </td>
          <td ${this.store.state.editableForm.standard_form_element ? 'hidden' : ''}>
            <input type="text" class="lh-form-collector-field-selector-input" ${selectorValue} data-field-type="${field.name.key}">
          </td>
          <td>
            <div class="lh-form-collector-remove-form-field" data-field-type="${field.name.key}">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.88463 5.0001L9.81717 1.06756C10.0615 0.823448 10.0615 0.427359 9.81717 0.183243C9.57285 -0.0610811 9.17718 -0.0610811 8.93285 0.183243L5.00031 4.11578L1.06756 0.183243C0.82324 -0.0610811 0.427568 -0.0610811 0.183243 0.183243C-0.0610811 0.427359 -0.0610811 0.823448 0.183243 1.06756L4.11599 5.0001L0.183243 8.93264C-0.0610811 9.17676 -0.0610811 9.57285 0.183243 9.81697C0.305406 9.93892 0.465509 10 0.625404 10C0.785299 10 0.945402 9.93892 1.06756 9.81676L5.00031 5.88422L8.93285 9.81676C9.05501 9.93892 9.21512 10 9.37501 10C9.53491 10 9.69501 9.93892 9.81717 9.81676C10.0615 9.57264 10.0615 9.17655 9.81717 8.93244L5.88463 5.0001Z" fill="#FFFFFF"/>
              </svg>
            </div>
          </td>
        </tr>`
      }
      fieldsItems += '</tbody></table>'
    }

    let freeFieldsItems = '<div class="lh-form-collector-form-editor-add-field"><div class="lh-form-collector-add-field-button" title="Выберите поле на странице Вашего сайта">Добавить поле</div></div>'

    formFieldsBlock.innerHTML = `${fieldsItems} ${freeFieldsItems}`

    setTimeout(function () {
      this.addFieldTypeListSelectInFormCollector()

      let addFieldButton = shadowContainer.shadowRoot.querySelector('.lh-form-collector-add-field-button')
      let removeFieldButtons = shadowContainer.shadowRoot.querySelectorAll('.lh-form-collector-remove-form-field')
      let fieldNameInputs = shadowContainer.shadowRoot.querySelectorAll('.lh-form-collector-field-name-input')
      let fieldAliasInputs = shadowContainer.shadowRoot.querySelectorAll('.lh-form-collector-field-alias-input')
      let fieldSelectorInputs = shadowContainer.shadowRoot.querySelectorAll('.lh-form-collector-field-selector-input')

      if (addFieldButton) {
        addFieldButton.onclick = function () {
          let sendFormByClickButton = shadowContainer.shadowRoot.querySelector('.lh-form-collector-form-editor-find-button-selector')

          if (addFieldButton.classList.contains('active')) {
            addFieldButton.classList.remove('active')
            document.body.onmouseover = null
            document.body.onmouseout = null
          } else {
            if (sendFormByClickButton) {
              sendFormByClickButton.classList.remove('active')
              this.turnOffFindingElementInPageInFormCollector()
            }

            addFieldButton.classList.add('active')
            document.body.onmouseover = this.findFieldMouseoverInFormCollector.bind(this)
            document.body.onmouseout = this.findFieldMouseoutInFormCollector.bind(this)
          }
        }.bind(this)
      }
      if (removeFieldButtons && removeFieldButtons.length > 0) {
        Array.from(removeFieldButtons).forEach(function (removeFieldButton) {
          removeFieldButton.onclick = function (event) {
            let removeButton = event.target.closest('.lh-form-collector-remove-form-field')
            if (!removeButton) return
            let removeFieldName = removeButton.getAttribute('data-field-type')

            this.store.state.editableForm.fields = this.store.state.editableForm.fields.filter(function (field) {
              if (field.name.key !== removeFieldName) return true
              else return false
            })

            this.updateFormFieldsBlock()
          }.bind(this)
        }.bind(this))
      }
      if (fieldNameInputs && fieldNameInputs.length > 0) {
        Array.from(fieldNameInputs).forEach(function (fieldNameInput) {
          fieldNameInput.oninput = function (fieldType) {
            let fieldNameInput = shadowContainer.shadowRoot.querySelector(`.lh-form-collector-field-name-input[data-field-type="${fieldType}"]`)
            this.store.state.editableForm.fields = this.store.state.editableForm.fields.map(function (field) {
              if (field.name.key === fieldType) {
                field.name.value = fieldNameInput.value
              }
              return field
            })
          }.bind(this, fieldNameInput.getAttribute('data-field-type'))
        }.bind(this))
      }
      if (fieldAliasInputs && fieldAliasInputs.length > 0) {
        Array.from(fieldAliasInputs).forEach(function (fieldAliasInput) {
          fieldAliasInput.oninput = function (fieldType) {
            let fieldAliasInput = shadowContainer.shadowRoot.querySelector(`.lh-form-collector-field-alias-input[data-field-type="${fieldType}"]`)
            this.store.state.editableForm.fields = this.store.state.editableForm.fields.map(function (field) {
              if (field.alias.key === fieldType) {
                field.alias.value = fieldAliasInput.value
              }
              return field
            })
          }.bind(this, fieldAliasInput.getAttribute('data-field-type'))
        }.bind(this))
      }
      if (fieldSelectorInputs && fieldSelectorInputs.length > 0) {
        Array.from(fieldSelectorInputs).forEach(function (fieldSelectorInput) {
          fieldSelectorInput.oninput = function (fieldType) {
            let fieldSelectorInput = shadowContainer.shadowRoot.querySelector(`.lh-form-collector-field-selector-input[data-field-type="${fieldType}"]`)
            this.store.state.editableForm.fields = this.store.state.editableForm.fields.map(function (field) {
              if (field.selector.key === fieldType) {
                field.selector.value = fieldSelectorInput.value
              }
              return field
            })
          }.bind(this, fieldSelectorInput.getAttribute('data-field-type'))
        }.bind(this))
      }
    }.bind(this), 0)
  }
  validateFormBeforeSaveInFormCollector () {
    if (this.store.state.editableForm.name.length > 0 && Object.keys(this.store.state.editableForm.fields).length > 0) {
      return true
    } else {
      return false
    }
  }
  backToFormsListInFormCollector () {
    let shadowContainer = document.querySelector('.lh-form-collector-shadow-continer')
    let formEditorContent = shadowContainer.shadowRoot.querySelector('.lh-form-collector-form-editor-content')
    let formListContainer = shadowContainer.shadowRoot.querySelector('.lh-form-collector-forms-list-body')
    let formEditorContainer = shadowContainer.shadowRoot.querySelector('.lh-form-collector-form-editor-body')

    formListContainer.classList.remove('lh-form-collector-display-none')
    formEditorContainer.classList.add('lh-form-collector-display-none')
    this.updateFormsListHtmlInFormCollector()
    formEditorContent.remove()
    this.turnOffFindingElementInPageInFormCollector()
  }

  updateFormInFormCollector () {
    let form = JSON.parse(JSON.stringify(this.store.state.editableForm))
    let fields = JSON.parse(JSON.stringify(form.fields))
    form.fields = {}
    form.fields_aliases = {}
    form.fields_selector = {}
    fields.forEach(function (field) {
      form.fields[field.name.value] = field.name.key
      form.fields_aliases[field.alias.key] = field.alias.value
      form.fields_selector[field.selector.key] = field.selector.value
    })

    let url = this.store.state.proto + this.store.state.trackUrlV2 + `site/${window.lh_clid}/forms`
    this.fetch(url, {
      'method': 'PATCH',
      'body': JSON.stringify(form)
    })
      .then(function (response) {
        response.text().then(function (response) {
          try {
            response = JSON.parse(response)
            if (response.status) {
              this.store.state.existingForms = this.store.state.existingForms.map(function (existingForm) {
                if (existingForm.id === this.store.state.editableForm.id) {
                  existingForm = JSON.parse(JSON.stringify(this.store.state.editableForm))
                }
                return existingForm
              }.bind(this))

              if (this.store.state.editableForm.standard_form_element) {
                alert('Форма обновлена успешно!')
              } else {
                this.updateFormScriptInFormCollector('Форма обновлена успешно!')
              }
            }
          } catch (e) {
            console.log('updateFormInFormCollector, Error: ', e)
          }
        }.bind(this))
      }.bind(this))
  }
  createFormInFormCollector () {
    let form = JSON.parse(JSON.stringify(this.store.state.editableForm))
    let fields = JSON.parse(JSON.stringify(form.fields))
    form.fields = {}
    form.fields_aliases = {}
    form.fields_selector = {}
    fields.forEach(function (field) {
      form.fields[field.name.value] = field.name.key
      form.fields_aliases[field.alias.key] = field.alias.value
      form.fields_selector[field.selector.key] = field.selector.value
    })

    let url = this.store.state.proto + this.store.state.trackUrlV2 + `site/${window.lh_clid}/forms`
    this.fetch(url, {
      'method': 'POST',
      'body': JSON.stringify(form)
    })
      .then(function (response) {
        response.text().then(function (response) {
          try {
            response = JSON.parse(response)
            if (response.status) {
              this.store.state.editableForm.id = response.form_id
              this.store.state.existingForms.push(JSON.parse(JSON.stringify(this.store.state.editableForm)))

              this.renderFormCollectorEditPage()

              if (this.store.state.editableForm.standard_form_element) {
                alert('Форма успешно создана!')
              } else {
                this.updateFormScriptInFormCollector('Форма успешно создана!')
              }
            }
          } catch (e) {
            console.log('createFormInFormCollector, Error: ', e)
          }
        }.bind(this))
      }.bind(this))
  }
  removeFormInFormCollector () {
    let url = this.store.state.proto + this.store.state.trackUrlV2 + `site/${window.lh_clid}/forms?form_id=${this.store.state.editableForm.id}`
    fetch(url, {
      'method': 'DELETE'
    })
      .then(function (response) {
        response.text().then(function (response) {
          try {
            response = JSON.parse(response)
            if (response.status) {
              this.store.state.existingForms = this.store.state.existingForms.filter(function (existingForm) {
                if (existingForm.id === this.store.state.editableForm.id) return false
                else return true
              }.bind(this))

              this.backToFormsListInFormCollector()

              if (this.store.state.editableForm.standard_form_element) {
                alert('Форма успешно удалена!')
              } else {
                this.updateFormScriptInFormCollector('Форма успешно удалена!')
              }

              this.store.state.editableForm = null
            }
          } catch (e) {
            console.log('removeFormInFormCollector, Error: ', e)
          }
        }.bind(this))
      }.bind(this))
  }
  generateFormsScriptInFormCollector () {
    /* eslint-disable */
    let codeText = `function addInputToForm(inputname, formlink, inputvalue) {\n`
    codeText += `  var input = document.createElement('input');\n`
    codeText += `  input.type = "hidden";\n`
    codeText += `  input.name = inputname;\n`
    codeText += `  input.id = "id_"+inputname;\n`
    codeText += `  input.value = inputvalue;\n`
    codeText += `  formlink.appendChild(input);\n`
    codeText += `}\n`
    codeText += `function isValidEmail(email) {\n`
    codeText += `  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;\n`
    codeText += `  return re.test(email);\n`
    codeText += `}\n`
    codeText += `function isValidPhone(phone) {\n`
    codeText += `  var re = /^[\s()+-]*([0-9][\s()+-]*){10,11}$/;\n`
    codeText += `  return re.test(phone);\n`
    codeText += `}\n`
    /* eslint-enable */

    let forms = this.store.state.existingForms.filter(function (form) {
      if (!form.standard_form_element) return true
      else return false
    })

    for (let i = 0; i < forms.length; i++) {
      let formVariableName = 'form' + (i + 1)
      codeText += `\nvar ${formVariableName} = document.createElement("form");\n`

      for (let j = 0; j < forms[i].fields.length; j++) {
        codeText += `addInputToForm('${forms[i].fields[j].name.value}', ${formVariableName}, '');\n`
      }

      if (!forms[i].by_click.active) {
        for (let j = 0; j < forms[i].fields.length; j++) {
          let inputVariableName = 'checkInput' + formVariableName + forms[i].fields[j].name.key
          codeText += `\rfunction ${inputVariableName}(event) {\n`

          if (forms[i].fields[j].name.key === 'email') {
            codeText += `  if (isValidEmail(this.value)) {\n`
            codeText += `    ${formVariableName}.id_${forms[i].fields[j].name.value}.value = this.value\n`
            codeText += `    window.lh_sf(${formVariableName});\n`
            codeText += `  }`
          } else if (forms[i].fields[j].name.key === 'phone') {
            codeText += `  if (isValidPhone(this.value)) {\n`
            codeText += `    ${formVariableName}.id_${forms[i].fields[j].name.value}.value = this.value\n`
            codeText += `    window.lh_sf(${formVariableName});\n`
            codeText += `  }`
          } else {
            codeText += `  ${formVariableName}.id_${forms[i].fields[j].name.value}.value = this.value\n`
            codeText += `  window.lh_sf(${formVariableName});`
          }
          codeText += '\r}'

          codeText += `\rtry {\n`

          codeText += `  document.querySelector('${forms[i].fields[j].selector.value}').addEventListener('keyup', ${inputVariableName})\n`
          codeText += `  document.querySelector('${forms[i].fields[j].selector.value}').addEventListener('blur', ${inputVariableName})\n`
          codeText += `  document.querySelector('${forms[i].fields[j].selector.value}').addEventListener('change', ${inputVariableName})\n`

          codeText += `} catch (e) {}\n`
        }
      } else {
        codeText += `try {\n`
        codeText += `  function live${formVariableName}(cb) {\n`
        codeText += `    document.addEventListener("click", function(event) {\n`
        codeText += `      var el = event.target, found;\n`
        codeText += `      while (el && !(found = el === document.querySelector('${forms[i].by_click.selector}'))) {\n`
        codeText += `        el = el.parentElement;\n`
        codeText += `      }\n`
        codeText += `      if (found) {\n`
        codeText += `        cb.call(el, event);\n`
        codeText += `      }\n`
        codeText += `    });\n`
        codeText += `  }\n`
        codeText += `  live${formVariableName}(function(event) {\n`

        for (let j = 0; j < forms[i].fields.length; j++) {
          codeText += `    ${formVariableName}.id_${forms[i].fields[j].name.value}.value = document.querySelector('${forms[i].fields[j].selector.value}').value\n`
        }

        codeText += `    window.lh_sf(${formVariableName});\n`
        codeText += `  });\n`
        codeText += `} catch (e) {}\n`
      }
    }

    return codeText
  }
  updateFormScriptInFormCollector (successMessage) {
    let formsScriptText = this.generateFormsScriptInFormCollector()
    let lhVars = JSON.parse(JSON.stringify(this.store.state.siteSettings.lh_vars || {}))
    lhVars.forms_script = formsScriptText

    let url = this.store.state.proto + this.store.state.trackUrlV2 + `update/lh_vars?site_id=${window.lh_clid}`
    this.fetch(url, {
      'method': 'PATCH',
      'body': JSON.stringify(lhVars)
    })
      .then(function (response) {
        response.text().then(function (response) {
          try {
            response = JSON.parse(response)
            this.store.state.siteSettings.lh_vars.forms_script = lhVars.forms_script

            if (response.status) {
              alert(successMessage)
            }
          } catch (e) {
            console.log('updateFormScriptInFormCollector, Error: ', e)
          }
        }.bind(this))
      }.bind(this))
  }

  renderFormCollectorEditPage () {
    let shadowContainer = document.querySelector('.lh-form-collector-shadow-continer')
    let formListContainer = shadowContainer.shadowRoot.querySelector('.lh-form-collector-forms-list-body')
    let formEditorContainer = shadowContainer.shadowRoot.querySelector('.lh-form-collector-form-editor-body')

    let removeButtonHtml = '<div class="lh-form-collector-form-editor-remove-button">Удалить</div>'
    if (!this.store.state.editableForm.hasOwnProperty('id')) {
      removeButtonHtml = ''
    }

    let formByClickCheckbox = ''
    if (!this.store.state.editableForm.standard_form_element && this.store.state.editableForm.fields.length > 0) {
      formByClickCheckbox = `<div class="lh-form-collector-form-editor-content-item lh-form-collector-form-editor-send-form-by-click">
        <input type="checkbox" id="lh-form-collector-send-form-by-click" ${this.store.state.editableForm.by_click.active ? 'checked' : ''}>
        <label for="lh-form-collector-send-form-by-click">
          Отправлять форму по клику на кнопку
        </label>
      </div>`
    }

    let formByClickInput = ''
    if (this.store.state.editableForm.by_click.active) {
      formByClickInput = `<div class="lh-form-collector-form-editor-content-item">
        <div class="lh-form-collector-form-editor-content-item-title">
          Селектор кнопки
        </div>
        <div class="lh-form-collector-form-editor-content-item-value lh-form-collector-form-editor-find-button-selector-cont">
          <input type="text" class="lh-form-collector-send-by-click-input" value="${this.store.state.editableForm.by_click.selector}">

          <div class="lh-form-collector-form-editor-find-button-selector">
            Выбрать на странице
          </div>
        </div>
      </div>`
    }

    formEditorContainer.innerHTML = `
    <div class="lh-form-collector-form-editor-content">
      <div class="lh-form-collector-form-editor-content-item">
        <div class="lh-form-collector-form-editor-content-item-title">
          Имя формы
        </div>
        <div class="lh-form-collector-form-editor-content-item-value">
          <input type="text" class="lh-form-collector-form-name-input" value="${this.store.state.editableForm.name}">
        </div>
      </div>

      <div class="lh-form-collector-form-editor-content-item">
        <div class="lh-form-collector-form-editor-content-item-title">
          Атрибут 'action' формы
        </div>
        <div class="lh-form-collector-form-editor-content-item-value">
          <input type="text" class="lh-form-collector-form-action-input" value="${this.store.state.editableForm.action}">
        </div>
      </div>

      <div class="lh-form-collector-form-editor-content-item lh-form-collector-form-editor-standart-form-checkbox">
        <input type="checkbox" id="lh-form-collector-standard-form-element" ${this.store.state.editableForm.standard_form_element ? 'checked' : ''}>
        <label for="lh-form-collector-standard-form-element">
          Форма является стандартной
        </label>
      </div>

      ${formByClickCheckbox}

      ${formByClickInput}

      <div class="lh-form-collector-form-editor-content-fields">
        <div class="lh-form-collector-form-editor-content-fields-title">
          Поля формы:
        </div>

        <div class="lh-form-collector-form-editor-content-fields-cont">
        </div>
      </div>

      <div class="lh-form-collector-form-editor-footer">
        <div class="lh-form-collector-form-editor-save-remove-buttons">
          <div class="lh-form-collector-form-editor-save-button">
            Сохранить
          </div>

          ${removeButtonHtml}
        </div>
        <div class="lh-form-collector-form-editor-back-forms-list">
          Список форм
        </div>
      </div>
    </div>`

    formListContainer.classList.add('lh-form-collector-display-none')
    formEditorContainer.classList.remove('lh-form-collector-display-none')

    setTimeout(function () {
      let backFormsList = shadowContainer.shadowRoot.querySelector('.lh-form-collector-form-editor-back-forms-list')
      let formNameInput = shadowContainer.shadowRoot.querySelector('.lh-form-collector-form-name-input')
      let formActionInput = shadowContainer.shadowRoot.querySelector('.lh-form-collector-form-action-input')
      let standartFormCheckbox = shadowContainer.shadowRoot.querySelector('input#lh-form-collector-standard-form-element')
      let sendFormByClickCheckbox = shadowContainer.shadowRoot.querySelector('input#lh-form-collector-send-form-by-click')
      let sendFormByClickInput = shadowContainer.shadowRoot.querySelector('.lh-form-collector-send-by-click-input')
      let sendFormByClickButton = shadowContainer.shadowRoot.querySelector('.lh-form-collector-form-editor-find-button-selector')
      let saveFormButton = shadowContainer.shadowRoot.querySelector('.lh-form-collector-form-editor-save-button')
      let removeFormButton = shadowContainer.shadowRoot.querySelector('.lh-form-collector-form-editor-remove-button')

      if (backFormsList) {
        backFormsList.onclick = this.backToFormsListInFormCollector.bind(this)
      }

      if (formNameInput) {
        formNameInput.oninput = function () {
          this.store.state.editableForm.name = formNameInput.value
        }.bind(this)
      }

      if (formActionInput) {
        formActionInput.oninput = function () {
          this.store.state.editableForm.action = formActionInput.value
        }.bind(this)
      }

      if (standartFormCheckbox) {
        standartFormCheckbox.onchange = function () {
          this.store.state.editableForm.standard_form_element = !this.store.state.editableForm.standard_form_element
          this.renderFormCollectorEditPage()
        }.bind(this)
      }

      if (sendFormByClickCheckbox) {
        sendFormByClickCheckbox.onchange = function () {
          this.store.state.editableForm.by_click.active = !this.store.state.editableForm.by_click.active
          this.renderFormCollectorEditPage()
        }.bind(this)
      }
      if (sendFormByClickInput) {
        sendFormByClickInput.oninput = function () {
          this.store.state.editableForm.by_click.selector = sendFormByClickInput.value
        }.bind(this)
      }

      if (sendFormByClickButton) {
        sendFormByClickButton.onclick = function () {
          let addFieldButton = shadowContainer.shadowRoot.querySelector('.lh-form-collector-add-field-button')

          if (sendFormByClickButton.classList.contains('active')) {
            sendFormByClickButton.classList.remove('active')
            document.body.onmouseover = null
            document.body.onmouseout = null
          } else {
            if (addFieldButton) {
              addFieldButton.classList.remove('active')
              this.turnOffFindingElementInPageInFormCollector()
            }

            sendFormByClickButton.classList.add('active')
            document.body.onmouseover = this.findButtonMouseoverInFormCollector.bind(this)
            document.body.onmouseout = this.findButtonMouseoutInFormCollector.bind(this)
          }
        }.bind(this)
      }

      if (saveFormButton) {
        saveFormButton.onclick = function () {
          if (this.validateFormBeforeSaveInFormCollector()) {
            if (!this.store.state.editableForm.hasOwnProperty('id')) {
              this.createFormInFormCollector()
            } else {
              let formToUpdate = this.getExistingFormById(this.store.state.editableForm.id)

              if (formToUpdate.name !== this.store.state.editableForm.name || formToUpdate.action !== this.store.state.editableForm.action || formToUpdate.standard_form_element !== this.store.state.editableForm.standard_form_element || formToUpdate.by_click.active !== this.store.state.editableForm.by_click.active || formToUpdate.by_click.selector !== this.store.state.editableForm.by_click.selector || JSON.stringify(formToUpdate.fields) !== JSON.stringify(this.store.state.editableForm.fields)) {
                this.updateFormInFormCollector()
              } else {
                alert('Нет необходимости обновлять форму')
              }
            }
          } else {
            alert("Форма должна содержать имя, атрибут 'action' и минимум одно поле!")
          }
        }.bind(this)
      }

      if (removeFormButton) {
        removeFormButton.onclick = function () {
          if (!this.store.state.editableForm.hasOwnProperty('id')) {
            this.backToFormsListInFormCollector()
          } else {
            let answer = confirm('Вы уверены, что хотите удалить форму?')
            if (answer) {
              this.removeFormInFormCollector()
            }
          }
        }.bind(this)
      }

      this.updateFormFieldsBlock()
    }.bind(this), 0)
  }
  showFormCollectorEditPage (event) {
    let formId = event.target.getAttribute('data-id')
    this.store.state.editableForm = JSON.parse(JSON.stringify(this.getExistingFormById(formId)))
    if (!this.store.state.editableForm) {
      this.store.state.editableForm = {
        name: '',
        action: '',
        fields: [],
        by_click: {
          active: false,
          selector: ''
        }
      }
    }

    this.renderFormCollectorEditPage()
  }
  addFormCollectorEvents () {
    let shadowContainer = document.querySelector('.lh-form-collector-shadow-continer')

    let moveIcon = shadowContainer.shadowRoot.querySelector('.lh-move-icon')
    let lhFormCollectorElement = shadowContainer.shadowRoot.querySelector('.lh-form-collector-element-wrapper')
    let closeIcon = shadowContainer.shadowRoot.querySelector('.lh-close-icon')
    let addFromButton = shadowContainer.shadowRoot.querySelector('.lh-form-collector-add-form')

    if (moveIcon) {
      moveIcon.onmousedown = function (event) {
        this.formCollectorStartMovePoints = {
          x: event.x,
          y: event.y
        }

        function moveAt (x, y) {
          lhFormCollectorElement.style.left = x + 'px'
          lhFormCollectorElement.style.top = y + 'px'
        }

        function onMouseMove (event) {
          if (!this.formCollectorStartMovePoints) return
          let params = lhFormCollectorElement.getBoundingClientRect()
          let diffX = this.formCollectorStartMovePoints.x - event.x
          let diffY = this.formCollectorStartMovePoints.y - event.y

          let newX = params.x - diffX
          let newY = params.y - diffY

          moveAt(newX, newY)

          this.formCollectorStartMovePoints.x = event.x
          this.formCollectorStartMovePoints.y = event.y
        }

        document.addEventListener('mousemove', onMouseMove.bind(this))

        moveIcon.onmouseup = function () {
          this.formCollectorStartMovePoints = null
          document.removeEventListener('mousemove', onMouseMove.bind(this))
          moveIcon.onmouseup = null
        }.bind(this)
      }
    }

    if (closeIcon) {
      closeIcon.onclick = function () {
        let alarmQuestion = confirm('Вы уверены, что хотите закрыть окно?\nНе сохраненные изменения будут потеряны!')
        if (alarmQuestion === true) {
          this.turnOffFindingElementInPageInFormCollector()
          localStorage.removeItem('lh-show-form-collector')
          lhFormCollectorElement.remove()
        }
      }.bind(this)
    }

    if (addFromButton) {
      addFromButton.onclick = this.showFormCollectorEditPage.bind(this)
    }
  }
  updateFormsListHtmlInFormCollector () {
    let shadowContainer = document.querySelector('.lh-form-collector-shadow-continer')
    let formListWrapper = shadowContainer.shadowRoot.querySelector('.lh-form-collector-forms-list-wrapper')

    let existingForms = '<div class="lh-form-collector-empty-forms-list">Формы отсутствуют</div>'
    if (this.store.state.existingForms.length > 0) {
      existingForms = '<ul class="lh-form-collector-forms-list">'
      for (let i = 0; i < this.store.state.existingForms.length; i++) {
        existingForms += `
        <li class="lh-form-collector-forms-list-item" data-id="${this.store.state.existingForms[i].id}">
          ${this.store.state.existingForms[i].name}
        </li>`
      }
      existingForms += '</ul>'
    }

    formListWrapper.innerHTML = existingForms

    setTimeout(function () {
      let formListItem = shadowContainer.shadowRoot.querySelectorAll('.lh-form-collector-forms-list-item')

      if (formListItem && formListItem.length > 0) {
        Array.from(formListItem).forEach(function (item) {
          item.onclick = this.showFormCollectorEditPage.bind(this)
        }.bind(this))
      }
    }.bind(this), 0)
  }
  showFormCollector () {
    let htmlElem = document.createElement('div')
    htmlElem.classList.add('lh-form-collector-element-wrapper')
    htmlElem.innerHTML = `
    <div class="lh-form-collector">
      <div class="lh-form-collector-header">
        <div class="lh-form-collector-header-title">
          LeadHit Формы
        </div>

        <div class="lh-form-collector-header-right">
          <div class="lh-move-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.8186 9.57988L16.5494 6.50297C16.3818 6.3452 16.1365 6.30215 15.9252 6.39348C15.7139 6.48477 15.5771 6.69289 15.5771 6.92309V8.26926H11.7309V4.42309H13.0771C13.3072 4.42309 13.5154 4.28629 13.6067 4.075C13.698 3.86371 13.655 3.61836 13.4972 3.45078L10.4202 0.181523C10.3112 0.0657031 10.1592 0 10.0001 0C9.84106 0 9.68903 0.0657031 9.58 0.181523L6.50309 3.45078C6.34532 3.61836 6.30231 3.86371 6.3936 4.075C6.48489 4.28629 6.69301 4.42309 6.92321 4.42309H8.26938V8.26926H4.42321V6.92309C4.42321 6.69293 4.28641 6.48477 4.07512 6.39348C3.86379 6.30219 3.61848 6.3452 3.4509 6.50297L0.181645 9.57988C0.0658252 9.68891 0.00012207 9.84094 0.00012207 10C0.00012207 10.1591 0.0658252 10.3111 0.181645 10.4201L3.45086 13.497C3.61844 13.6548 3.86375 13.6979 4.07508 13.6065C4.28637 13.5152 4.42317 13.3071 4.42317 13.0769V11.7307H8.26934V15.5769H6.92317C6.69301 15.5769 6.48485 15.7137 6.39356 15.925C6.30227 16.1363 6.34528 16.3816 6.50305 16.5492L9.57997 19.8184C9.68895 19.9343 9.84102 20 10.0001 20C10.1591 20 10.3112 19.9343 10.4202 19.8184L13.4971 16.5492C13.6549 16.3816 13.6979 16.1363 13.6066 15.925C13.5153 15.7137 13.3072 15.5769 13.077 15.5769H11.7308V11.7307H15.577V13.0769C15.577 13.3071 15.7138 13.5152 15.9251 13.6065C16.1364 13.6978 16.3818 13.6548 16.5493 13.497L19.8185 10.4201C19.9344 10.3111 20 10.1591 20 10C20 9.84094 19.9344 9.68891 19.8186 9.57988Z" fill="#CFD0D1"/>
            </svg>
          </div>

          <div class="lh-close-icon">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.88463 5.0001L9.81717 1.06756C10.0615 0.823448 10.0615 0.427359 9.81717 0.183243C9.57285 -0.0610811 9.17718 -0.0610811 8.93285 0.183243L5.00031 4.11578L1.06756 0.183243C0.82324 -0.0610811 0.427568 -0.0610811 0.183243 0.183243C-0.0610811 0.427359 -0.0610811 0.823448 0.183243 1.06756L4.11599 5.0001L0.183243 8.93264C-0.0610811 9.17676 -0.0610811 9.57285 0.183243 9.81697C0.305406 9.93892 0.465509 10 0.625404 10C0.785299 10 0.945402 9.93892 1.06756 9.81676L5.00031 5.88422L8.93285 9.81676C9.05501 9.93892 9.21512 10 9.37501 10C9.53491 10 9.69501 9.93892 9.81717 9.81676C10.0615 9.57264 10.0615 9.17655 9.81717 8.93244L5.88463 5.0001Z" fill="#CFD0D1"/>
            </svg>
          </div>
        </div>
      </div>

      <div class="lh-form-collector-forms-list-body">
        <div class="lh-form-collector-forms-list-body-title">
          Список форм:
        </div>

        <div class="lh-form-collector-forms-list-wrapper">
        </div>

        <div class="lh-form-collector-forms-list-footer">
          <div class="lh-form-collector-add-form">
            Добавить форму
          </div>
        </div>
      </div>

      <div class="lh-form-collector-form-editor-body lh-form-collector-display-none">
      </div>
    </div>
    `

    let cssElem = document.createElement('style')
    cssElem.type = 'text/css'
    let css = `
    .lh-form-collector-element-wrapper {
      background: white;
      border: 1px solid;
      border-radius: 3px;
      position: fixed;
      top: 50px;
      left: 50px;
      resize: both;
      overflow: auto;
      font-size: 14px;
      z-index: 999999999;
    }
    .lh-form-collector-element-wrapper input {
      height: 19px;
      padding: 3px 5px;
    }
    .lh-form-collector {
      height: calc(100% - 5px);
    }
    .lh-form-collector-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 5px 10px;
    }
    .lh-form-collector-header-title {
      margin-right: 15px;
    }
    .lh-form-collector-header-right {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .lh-move-icon {
      cursor: move;
      background: #2C3236;
      width: 30px;
      height: 30px;
      border: 1px solid transparent;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .lh-close-icon {
      margin-left: 10px;
      background: #2C3236;
      width: 30px;
      height: 30px;
      border: 1px solid transparent;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .lh-move-icon:hover svg path, .lh-close-icon:hover svg path {
      fill: #FF4402;
    }

    .lh-form-collector-forms-list {
      column-count: 2;
    }
    .lh-form-collector-forms-list-body-title {
      margin-bottom: 5px;
      padding: 0 10px;
    }
    .lh-form-collector-forms-list-body {
      min-height: calc(100% - 40px);
    }
    .lh-form-collector-empty-forms-list {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 50px 0;
    }
    .lh-form-collector-forms-list-item:hover {
      cursor: pointer;
      text-decoration: underline;
    }
    .lh-form-collector-forms-list-wrapper {
      margin-right: 10px;
    }

    .lh-form-collector-forms-list-footer {
      display: flex;
      justify-content: flex-end;
      padding: 5px 10px 10px 10px;
    }
    .lh-form-collector-add-form, .lh-form-collector-form-editor-back-forms-list, .lh-form-collector-add-field-button, .lh-form-collector-form-editor-save-button, .lh-form-collector-form-editor-remove-button, .lh-form-collector-form-editor-find-button-selector {
      border: 1px solid;
      border-radius: 3px;
      padding: 3px 10px;
      cursor: pointer;
      user-select: none;
    }
    .lh-form-collector-add-form:hover, .lh-form-collector-form-editor-back-forms-list:hover, .lh-form-collector-add-field-button:hover, .lh-form-collector-add-field-button.active, .lh-form-collector-form-editor-save-button:hover, .lh-form-collector-form-editor-find-button-selector:hover, .lh-form-collector-form-editor-find-button-selector.active {
      background: #2C3236;
      color: #CFD0D1;
      border-color: #2C3236;
    }
    .lh-form-collector-form-editor-save-button {
      margin-right: 15px;
    }
    .lh-form-collector-form-editor-remove-button:hover {
      background: red;
      border-color: red;
      color: white;
    }
    .lh-form-collector-form-editor-find-button-selector-cont {
      display: flex;
    }
    .lh-form-collector-send-by-click-input {
      margin-right: 15px;
    }

    .lh-form-collector-form-editor-footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
    .lh-form-collector-form-editor-save-remove-buttons {
      display: flex;
    }
    .lh-form-collector-form-editor-body {
      padding: 0 10px 10px 10px;
      min-width: fit-content;
    }
    .lh-form-collector-form-editor-content {
      min-width: 400px;
    }
    .lh-form-collector-form-editor-content-fields {
      border: 1px solid;
      border-radius: 3px;
      padding: 10px;
    }
    .lh-form-collector-form-editor-content-fields-container th {
      text-align: center;
    }
    .lh-form-collector-form-editor-content-fields-container td {
      padding-top: 3px;
      padding-bottom: 3px;
    }
    .lh-form-collector-form-editor-content-fields-container th:not(:last-child) {
      padding-right: 10px;
    }
    .lh-form-collector-form-editor-content-fields-container td:not(:last-child) {
      padding-right: 10px;
    }
    .lh-form-collector-form-editor-content-item {
      margin-bottom: 15px;
    }
    .lh-form-collector-form-editor-standart-form-checkbox {
      display: flex;
      align-items: center;
      display: none;
    }
    .lh-form-collector-form-editor-standart-form-checkbox label {
      margin-left: 3px;
      cursor: pointer
    }
    .lh-form-collector-form-editor-standart-form-checkbox input {
      cursor: pointer;
    }
    .lh-form-collector-form-editor-send-form-by-click {
      display: flex;
      align-items: center;
    }
    .lh-form-collector-form-editor-send-form-by-click label {
      margin-left: 3px;
      cursor: pointer
    }
    .lh-form-collector-form-editor-send-form-by-click input {
      cursor: pointer
    }
    .lh-form-collector-remove-form-field {
      background: red;
      border: 1px solid transparent;
      border-radius: 20px;
      width: 20px;
      height: 20px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .lh-form-collector-form-editor-add-field {
      margin-top: 15px;
      display: flex;
    }
    .lh-form-collector-form-editor-select-field-type select {
      padding: 3px 5px;
      height: 29px;
    }

    .lh-form-collector-display-none {
      display: none !important;
    }
    `
    if (cssElem.styleSheet) {
      cssElem.styleSheet.cssText = css
    } else {
      cssElem.appendChild(document.createTextNode(css))
    }

    let shadowContainer = document.createElement('div')
    shadowContainer.classList.add('lh-form-collector-shadow-continer')
    document.body.append(shadowContainer)
    shadowContainer.attachShadow({ mode: 'open' })

    shadowContainer.shadowRoot.append(cssElem)
    shadowContainer.shadowRoot.append(htmlElem)

    setTimeout(function () {
      this.updateFormsListHtmlInFormCollector()
      this.addFormCollectorEvents()
    }.bind(this), 0)
  }

  init () {
    let sess = Utils.readCookie('_lhtm_r')

    if (sess) {
      window.lh_vid = sess.split('|')[1]
      window.lh_ref = sess.split('|')[0]
    }

    this.store.state.isFirstVisit = !Utils.checkIsValidObjectIdForMongoDB(this.getUID())
    this.store.state.domain = location.host.replace('www.', '')
    window.lh_sf = this.saveFormToLocalStorage.bind(this)

    if (typeof window._lh_params !== 'undefined') {
      this.store.state.params = window._lh_params
    }

    this.debugLog('Leadhit init complete')

    // Legacy code for old widgets
    window.lh_banner_data = {}
  }
}

export default Leadhit
